<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <div class="d-flex flex-row px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-0">Create Reservation</p>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon small class="pl-1" v-on="on">mdi-help-circle</v-icon>
          </template>
          <p class="white--text" style="width: 300px">
            This creates an unpaid, pending reservation and sends a notification
            email to the tenant.
          </p>
        </v-tooltip>
      </div>
      <v-stepper v-model="e1" class="px-4">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Find User</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2"
            >Confirm User</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step step="3">Enter Details</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content
            v-if="newTenantMode == 'user'"
            step="1"
            class="pt-0"
          >
            <v-text-field
              v-model="username"
              name="username"
              label="Username or E-mail"
              :loading="loading"
              prepend-inner-icon="mdi-account"
              class="px-md-12 mt-1"
              outlined
              dense
              @keydown.enter="next(2)"
            ></v-text-field>
            <!-- <v-container class="d-flex flex-column align-center">
              <span class="caption">or</span>
              <a class="body-2" @click="setEnterEmail">Enter e-mail to create a new user</a>
            </v-container> -->

            <v-card-actions class="pt-6">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!username || loading"
                color="primary darken-1"
                text
                @click="next(2)"
                >Next</v-btn
              >
              <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="2" class="pt-0">
            <v-form v-if="userDetails" v-model="form2">
              <v-container class="pa-0">
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="3">
                    <p class="caption">Name:</p>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="9">
                    <p class="caption font-weight-bold">
                      {{ userDetails.firstName }} {{ userDetails.lastname }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="3">
                    <p class="caption">Username:</p>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="9">
                    <p class="caption font-weight-bold">
                      {{ userDetails.username }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="3">
                    <p class="caption">Email Address:</p>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="9">
                    <p class="caption font-weight-bold">
                      {{ userDetails.email1 }}
                    </p>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
                <v-row>
                  <v-col cols="12" md="12" class="mb-n2">
                    <p class="font-weight-bold">Additional Details</p>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="aliasName"
                      outlined
                      dense
                      label="Add an alias"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="aliasNumber"
                      outlined
                      dense
                      label="Contact Number"
                      :rules="phMobileRules"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div v-if="!userDetails">
              <p class="headline">User {{ username }} does not exist</p>
              <p class="subtitle-1">
                Create a new user with email {{ username }}?
              </p>
            </div>
            <v-card-actions class="pt-6">
              <v-spacer></v-spacer>
              <v-btn color="secondary darken-1" text @click="back">Back</v-btn>
              <v-btn
                v-if="userDetails"
                color="primary darken-1"
                text
                :disabled="loading"
                @click="next(3)"
                >Next</v-btn
              >
              <v-btn
                v-else-if="!userDetails"
                color="primary darken-1"
                text
                :disabled="loading"
                @click="createTempUser"
                >Yes</v-btn
              >
              <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="3" class="pt-0">
            <v-form>
              <v-container class="pa-0">
                <v-row>
                  <v-col class="pb-0" cols="12" sm="12" md="6">
                    <v-currency-field
                      v-model="reservationFee"
                      type="number"
                      :rules="reservationFeeRules"
                      label="Reservation Fee"
                      prepend-inner-icon="mdi-cash"
                      required
                      dense
                      outlined
                    ></v-currency-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <v-textarea
                      v-model="notes"
                      label="Notes"
                      placeholder="Enter notes here"
                      prepend-inner-icon="mdi-text"
                      required
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <v-checkbox
                      v-model="durationAvailable"
                      label="Set Reservation Duration"
                      color="primary"
                      class="ml-2"
                      @change="durationAvailableChange"
                    ></v-checkbox>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <v-select
                      v-model="duration"
                      :items="durationItems"
                      label="Automatically Cancel Reservation After:"
                      prepend-inner-icon="mdi-calendar-today"
                      required
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col cols="12" sm="12" md="6">
                    <v-menu
                      ref="dateCreatedDateMenuRef"
                      v-model="dateCreatedDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dateCreated"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateCreated"
                          label="Date Created"
                          prepend-inner-icon="mdi-calendar-month"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="dateCreatedDatePicker">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateCreatedDateMenu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dateCreatedDateMenuRef.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col> -->
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <v-checkbox
                      v-model="moveInDateAvailable"
                      label="Set Move In Date"
                      color="primary"
                      class="ml-2"
                      @change="moveInDateAvailableChange"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="6">
                    <v-menu
                      v-model="moveInDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      :disabled="!moveInDateAvailable"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="moveInDate"
                          label="Move In Date"
                          :disabled="!moveInDateAvailable"
                          v-bind="attrs"
                          readonly
                          dense
                          outlined
                          v-on="on"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small class="mt-1"
                              >mdi-calendar-month</v-icon
                            >
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="moveInDate"
                        no-title
                        scrollable
                        @input="moveInDateMenu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-card-actions class="pt-6">
              <v-spacer></v-spacer>
              <v-btn color="secondary darken-1" text @click="back">Back</v-btn>
              <v-btn
                color="primary darken-1"
                :disabled="!reservationFee || loading"
                text
                @click="finish"
              >
                Finish
              </v-btn>
              <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data: () => ({
    newTenantMode: 'user',
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 700,
      zIndex: 200
    },
    loading: false,
    username: '',
    userDetails: {},
    items: [],
    search: null,
    e1: 1,
    reservationFee: 0,
    notes: null,
    // dateCreated: dayjs().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD'),
    moveInDate: null,
    moveInDatePicker: dayjs()
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    // dateCreatedDatePicker: dayjs().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD'),
    moveInDateMenu: false,
    // dateCreatedDateMenu: false,
    snackbar: false,
    reservationFeeRules: [
      (v) => (v != null && v != undefined) || 'Reservation Fee is Required.',
      (v) =>
        Number.isInteger(parseInt(v)) || 'Reservation Fee must be a number.'
    ],
    moveInDateAvailable: false,
    snackbarText: '',
    durationAvailable: true,
    duration: 30,
    durationItems: [
      { value: 7, text: '1 week' },
      { value: 14, text: '2 weeks' },
      { value: 30, text: '1 month' },
      { value: 60, text: '2 months' },
      { value: 90, text: '3 months' },
      { value: 180, text: '6 months' },
      { value: 365, text: '1 year' }
    ],
    aliasName: '',
    aliasNumber: ''
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
    // moveInDate() {
    //   return this.moveInDateAvailable?dayjs().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD'):undefined
    // }
  },
  watch: {
    search(val) {
      val && val !== this.username && this.querySelections(val)
    }
    // moveInDatePicker () {
    //   this.moveInDate = this.formatDate(this.moveInDatePicker)
    // },
    // dateCreatedDatePicker () {
    //   this.dateCreated = this.formatDate(this.dateCreatedDatePicker)
    // },
  },
  methods: {
    open() {
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async next(step) {
      if (step == 2) {
        this.loading = true
        await this.$store.dispatch('users/fetchSelectedUserAction', {
          username: this.username
        })
        this.userDetails = this.$store.getters['users/getSelectedUser']
        this.aliasName = this.userDetails.alias
        this.aliasNumber = this.userDetails.aliasNumber
        this.loading = false

        if (
          this.userDetails.userId === this.$store.getters['auth/getUser'].userId
        ) {
          this.snackbarText = "You can't reserve yourself"
          this.snackbar = true
        } else if (this.userDetails) {
          this.e1 = step
        } else {
          if (validateEmail(this.username)) {
            this.e1 = step
          } else {
            this.snackbarText = 'Username does not exist'
            this.snackbar = true
          }
        }
      } else {
        this.e1 = step
      }
    },
    cancel() {
      this.e1 = 1
      this.resolve(false)
      this.dialog = false
    },
    back() {
      this.e1 -= 1
    },
    async finish() {
      this.loading = true
      try {
        await this.$store.dispatch('reservations/newReservationAction', {
          tenantId: this.userDetails.userId,
          reservationFee: this.reservationFee,
          notes: this.notes,
          // dateCreated: this.dateCreated,
          moveInDate:
            (this.moveInDate && dayjs(this.moveInDate).format()) || '',
          endDate:
            this.durationAvailable && this.duration
              ? dayjs().add(this.duration, 'day').format()
              : undefined,
          alias: {
            name: this.aliasName,
            contactNumber: this.aliasNumber
          }
        })
        this.loading = false
        this.dialog = false
        this.$root
          .$confirm({
            title: 'New Tenant',
            message: `Reservation has been created.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(async () => {
            this.resolve(true)
          })
      } catch (err) {
        this.loading = false
        this.snackbarText = err.data
        this.snackbar = true
      }
    },
    querySelections(v) {
      this.loading = true
      setTimeout(() => {
        this.$store
          .dispatch('users/fetchCachedUsersAction', { username: v })
          .then(() => {
            this.items = this.$store.getters['users/getCachedUsers']
            this.loading = false
          }, 5000)
      })
    },
    // formatDate (date) {
    //   if (!date) return null

    //   const [year, month, day] = date.split('-')
    //   return `${month}/${day}/${year}`
    // },
    // parseDate (date) {
    //   if (!date) return null

    //   const [month, day, year] = date.split('/')
    //   return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    // },
    setEnterEmail() {
      this.newTenantMode = 'email'
    },
    async createTempUser() {
      // this.username may contain username or email
      this.loading = true
      await this.$store.dispatch('users/createTempUserAction', {
        email: this.username
      })
      this.loading = false
      this.userDetails = this.$store.getters['users/getSelectedUser']
      this.next(3)
    },
    moveInDateAvailableChange() {
      if (this.moveInDateAvailable) {
        this.moveInDate = dayjs()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format('YYYY-MM-DD')
      } else {
        this.moveInDate = null
      }
    },
    durationAvailableChange() {
      if (this.durationAvailable) {
        this.duration = 30
      } else {
        this.duration = null
      }
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.v-card.card-option,
.v-expansion-panel {
  border-radius: 20px !important;
}
.v-stepper__header,
.v-stepper,
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
